import React from "react"

import { useTranslation, useBounceGlobalValues, DEFAULT_LANGUAGE } from "@bounce/i18n"

import { Hero } from "./components/Hero/Hero"
import { Posts } from "./components/Posts"
import { Layout } from "@/components/LuggageStorage/Layout/Layout"
import type { FormattedBlogPostPreview } from "@/libs/prismic/types"
import { useUrl } from "@/libs/router"

export type BlogScreenProps = {
  articleData: FormattedBlogPostPreview[]
}

const BlogScreen = ({ articleData }: BlogScreenProps) => {
  const { t } = useTranslation("marketing-generic")
  const bounceGlobals = useBounceGlobalValues()
  const { absolutePath } = useUrl()

  return (
    <Layout
      headProps={{
        url: absolutePath,
        title: t("screen.blog.metaTitleV4", "Bounce - Blog | Luggage Storage in {{numCities}}+ Cities", {
          numCities: bounceGlobals.numCities,
        }),
        description: t(
          "screen.blog.metaDescription",
          "Find all of Bounce’s articles on our blog. Also, you can find a visitor guide for each of our top cities.",
        ),
      }}
      languages={[DEFAULT_LANGUAGE]}>
      <Hero articleData={articleData} />
      <Posts articleData={articleData} />
    </Layout>
  )
}

export default BlogScreen
